import React, { Fragment, useState } from 'react';
import { Button, CircularProgress, Grid } from '@material-ui/core';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IStandardAppProps } from '../../Models/IStandardAppProps';
import { computed } from 'mobx';
import { observer } from 'mobx-react';

interface ITelematicsPlantingSummaryButtonProps extends IStandardAppProps
{
	handleGenerateSummary: (startDate:Date, endDate:Date) => void;
	isGenerating: boolean;
	startDate:  Date;
	endDate: Date;
}

interface ISummaryState {
	startDate:  Date,
	endDate: Date,
}

/** This element wraps the button for generating a summary */
@observer
export class TelematicsPlantingSummaryButton  extends React.PureComponent<ITelematicsPlantingSummaryButtonProps, ISummaryState>
{   
	public constructor(props: ITelematicsPlantingSummaryButtonProps)
	{
		super(props);
		this.state = {
			startDate: props.startDate,
			endDate: props.endDate,
		}
	}

	@computed 
	public get SummaryMessage()
	{
		return this.props.applicationState.summaryMessage;
	} 

	@computed 
	public get LastRunDate()
	{
		return this.props.dataStore.lastSummaryTime;
	} 

	onChangeStartDate = (date : Date) => {
		this.setState({startDate: date});
	}

	onChangeEndDate = (date : Date) => {
		this.setState({endDate: date});
	}

	onClick = () => 
	{
		this.props.handleGenerateSummary(this.state.startDate, this.state.endDate);
	}

	public render()
	{

		return <Fragment>
			<Grid item>
				<div className="PlantingSummaryButtonContainer" style={{ position: 'relative', }}>
					<Button variant="outlined" color="primary" disabled={this.props.isGenerating} onClick={this.onClick}>Generate Summary</Button>
					{
						this.props.isGenerating ?
							<div className="ScanLoader">
								<CircularProgress size={32} />
							</div>
							: <></>
					}
				</div>
			</Grid>
			<Grid item>
				<div className="PlantingSummaryStartDateContainer" style={{ position: 'relative', padding: '6px 0 7px 10px' }}>
					<label>Start Date: </label>
					<DatePicker
						selected={this.state.startDate}
						onChange={this.onChangeStartDate}
					/>
				</div>
			</Grid>
			<Grid item>
				<div className="PlantingSummaryEndDateContainer" style={{ position: 'relative', padding: '6px 0 7px 10px' }}>
					<label>End Date: </label>
					<DatePicker
						selected={this.state.endDate}
						onChange={this.onChangeEndDate}
					/>
				</div>
			</Grid>
			<span style={{ position: 'relative', padding: '6px 0 7px 10px' }}>Summary Status: {this.SummaryMessage}</span>
			<span style={{ position: 'relative', padding: '6px 0 7px 10px' }}>Last End Date: {this.LastRunDate}</span>
		</Fragment>
	}
}
